import axios, { AxiosInstance } from 'axios';
import { getAccessToken, onUnauthorized } from './auth';
import { bookingsURL } from '.';

export type Booking = {
  id: string;
  customerID: string;
  centerID: string;
  colaboratorID: string;
  date: string;
  serviceID: string;
  serviceDurationInMinutes: number;
  status: 'booked' | 'cancelled' | 'performed';
  cancelReason: string;
};

export function getBookingApi(): AxiosInstance {
  const accessToken = getAccessToken();
  if (!accessToken) {
    onUnauthorized();
    throw new Error('Sessão expirada');
  }

  return axios.create({
    baseURL: bookingsURL,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}

export async function getAllBookings() {
  const api = getBookingApi();

  const res = await api.get('');

  return res.data as Booking[];
}

export type BookRequest = {
  customerID: string;
  colaboratorID: string;
  centerID: string;
  serviceID: string;
  date: string;
};
export async function book(bookRequest: BookRequest) {
  const api = getBookingApi();

  const res = await api.post('', bookRequest);
  return res.data;
}

export type CancelBookingRequest = {
  bookingID: string;
};

export async function cancelBooking(
  input: { colaboratorID: string } & CancelBookingRequest,
) {
  const api = getBookingApi();
  const res = await api.post(`${input.colaboratorID}/cancel`, {
    bookingID: input.bookingID,
  });

  return res.data;
}

export type RescheduleBookingRequest = {
  bookingID: string;
  newDate: string;
};

export async function rescheduleBooking(
  input: { colaboratorID: string } & RescheduleBookingRequest,
) {
  const api = getBookingApi();
  const res = await api.post(`${input.colaboratorID}/reschedule`, {
    bookingID: input.bookingID,
    newDate: input.newDate,
  });

  return res.data;
}
